import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { EvendProduct, EvendProductTag, EvendProductType } from '../models/evendProduct';
import { ProductService } from '../services/product.service';
import {environment} from '../../environments/environment';
import { ProductCategory } from '../models/productCategory';
import { ProductBrand } from '../models/productBrand';
import { CategoryService } from '../services/category.service';
import { BrandService } from '../services/brand.service';
import { TagService } from '../services/tag.service';

declare var $: any;

@Component({
    selector: 'app-product-filter',
    templateUrl: './product-filter.component.html',
    styleUrls: ['./product-filter.component.css']
})
export class ProductFilterComponent implements OnInit {
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;

    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    evendProducts = [new EvendProduct()];
    evendProduct = new EvendProduct();
    totalCountOfEvendProduct = 0;
    searchText;
    selector: string = '.evend-products-list';
    errorMessage = '';
    deleteIndexForEvendProduct = -1; // Current evend product array index
    categories: ProductCategory[];
    brands: ProductBrand[];
    tags: EvendProductTag[];
    productTypes: EvendProductType[];
    productType: EvendProductType;
    loading = false;

    filter: number = -1;
    @ViewChild('editCropInput') editCropInput: ElementRef;
    editImageChangedEvent: any = '';
    editCroppedImage: any = '';
    editCropperReady = false;
    
    constructor(
        private route: ActivatedRoute, 
        private router: Router,
        private productService: ProductService,
        private spinner: NgxSpinnerService,
        private categoryService: CategoryService,
        private brandService: BrandService,
        private tagService: TagService,
    ) { }
    productTypeName : string = '';
    productTypeId : string = '';
    productBrandName : string = '';
    productBrandId : string = '';
    productCategoryName : string = '';
    productCategoryId: string = '';
    whichPage: string = 'all';
    evendProductpage = 1;
    evendProductpages = 1;
    brandPage = 1;
    brandPages = 1;
    categoryPage = 1;
    categoryPages = 1;
    tagPage = 1;
    tagPages = 1;
    typePage = 1;
    typePages = 1;

    ProductImagePath: string;

    ngOnInit() {
        this.ProductImagePath = environment.ProductImagePath;
        this.route.queryParams.subscribe(params => {
            let data = params;
            this.whichPage = data.page;
            if (data.page === 'productType') {                
                if (data._id) {
                    this.productTypeId = data._id;
                }
                if (data.name) {
                    this.productTypeName = data.name;
                }
            } else if (data.page === 'productBrand') {
                if (data._id) {
                    this.productBrandId = data._id;
                }
                if (data.name) {
                    this.productBrandName = data.name;
                }
            } else if(data.page === 'productCategory') {
                if (data._id) {
                    this.productCategoryId = data._id;
                }
                if (data.name) {
                    this.productCategoryName = data.name;
                }
            } else {
                this.whichPage = 'all';
                this.productBrandId = '';
                this.productCategoryId = '';
                this.productTypeId = '';
            }
            this.getEvendProducts();
          });
        this.productService.getEvendProductTypes(this.typePage).subscribe(res => {
            this.productTypes = res.docs;
            this.productType = this.productTypes[0];
            this.typePages = res.pages;
          }, error => {
            console.log(error);
            if (error.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              this.errorSwal.title = error.status;
              this.errorSwal.text = error.error;
              this.errorSwal.show();
              console.log('Error:', error);
            }
          });
          this.categoryService.getCategories(this.categoryPage).subscribe(res => {
            this.categories = res.docs;
            this.categoryPages = res.pages;
          }, error => {
            console.log(error);
            if (error.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              this.errorSwal.title = error.status;
              this.errorSwal.text = error.error;
              this.errorSwal.show();
              console.log('Error:', error);
            }
          });
          this.brandService.getAllBrands(this.brandPage).subscribe(res => {
            this.brands = res.docs;
            this.brandPages = res.pages;
          }, error => {
            console.log(error);
            if (error.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              this.errorSwal.title = error.status;
              this.errorSwal.text = error.error;
              this.errorSwal.show();
              console.log('Error:', error);
            }
          });
          this.getevendProductTags();
          this.evendProducts.forEach((evendProduct) => {
            evendProduct.status = -1;
          });
      
    }

    getevendProductTags() {
        this.tagService.getAllTags(this.tagPage).subscribe(res => {
            this.tags = res.docs;
            this.tagPages = res.pages;
          }, error => {
            if (error.message === 'Error: Access Denied') {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              if (this.errorSwal) {                
                  this.errorSwal.title = error.status;
                  this.errorSwal.text = error.error;
                  this.errorSwal.show();
              }
              console.log('Error:', error);
            }
          });
    }
    openNewProductPage() {
        this.router.navigate(['/add-product']);
    }

    getEvendProducts() {
        this.evendProductpage = 1;
        this.spinner.show();
        this.productService.getEvendProductsSuperAdmin(this.evendProductpage, 
            {
                categoryId: this.productCategoryId,
                brandId: this.productBrandId ,
                name:'',
                status: this.filter,
                evendProductType:this.productTypeId
            }).subscribe(res => {
            this.evendProducts = res.result.docs;
            this.evendProductpages = res.result.pages;
            this.totalCountOfEvendProduct = res.result.total;
            this.spinner.hide();
        }, error => {
            if (error.status === 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.spinner.hide();
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.message;
                this.errorSwal.show();
            }
        });
    }

    deleteEvendProduct(_id) {
        this.spinner.show();
        this.deleteIndexForEvendProduct = this.evendProducts.indexOf(this.evendProducts.find(x => x._id === _id));
        this.productService.deleteEvendProduct(_id).subscribe(res => {
            this.successSwal.text = 'Ürün başarıyla silindi!';
            this.successSwal.show();
            this.evendProducts.splice(this.deleteIndexForEvendProduct, 1);
            this.getEvendProducts();
            this.spinner.hide();
        }, error => {
            this.spinner.hide();
            if (error.retCode !== 1) {
                this.errorSwal.text = 'Ürün silinirken hata oluştu!';
                this.errorSwal.show();
            } else {
                this.errorSwal.text = 'Ürünü ürün havuzundan silebilmek için önce firma ürünleri içerisinden çıkarmanız gerekmektedir!';
                this.errorSwal.show();
            }
        });
    }

    updateEvendProduct() {
        if (!this.checkIsFieldsOkay()) { return; }
       

        this.productService.updateEvendProduct(this.evendProduct, this.evendProduct._id, this.productType._id).subscribe(response => {
            if (this.editCroppedImage && this.editCroppedImage !== '') {
                let fileName = this.editCropInput.nativeElement.files[0].name;
                fileName = fileName.split('.');
                const formData = new FormData();
                const ImageFile = this.convertToFile(this.editCroppedImage,
                    fileName[0] + '_' + this.evendProduct._id + '.' + fileName[1]);
                formData.append('upfile', ImageFile);
                this.productService.uploadEvendProductImage(formData, this.evendProduct._id).subscribe(
                    res => {
                        this.successSwal.text = 'Ürün başarıyla güncellendi!';
                        this.successSwal.show();
                        this.closeUpdateModal.nativeElement.click();
                        }, error => {
                        this.errorSwal.text = 'Ürün resmi güncellenirken hata oluştu!';
                        this.errorSwal.show();
                    });
                this.getBrand(this.evendProduct.brand._id);
                this.getCategory(this.evendProduct.categories[0]._id);
                this.getEvendProducts();
                this.spinner.hide();
            } else {
                this.spinner.hide();
                this.successSwal.text = 'Ürün resmi değiştirilmeden başarıyla güncellendi!';
                this.successSwal.show();
                this.closeUpdateModal.nativeElement.click();
                this.getBrand(this.evendProduct.brand._id);
                this.getCategory(this.evendProduct.categories[0]._id);
                this.getEvendProducts();
            }
        }, error => {
            this.spinner.hide();
            this.errorSwal.text = 'Ürün güncellenirken hata oluştu!';
            this.errorSwal.show();
        });


    }

    setProduct(evendProduct) {
        this.clearProduct();
        this.evendProduct = Object.assign({}, evendProduct);
        this.deleteIndexForEvendProduct = this.evendProducts.indexOf(evendProduct);
       /*  this.evendProduct.tags = [];
        evendProduct.tags.forEach(tag => {
            this.evendProduct.tags.push(tag._id);
        }); */
    }

    search(term: string, item: any) {
        return item.name.toLocaleLowerCase().trim().includes(term.toLocaleLowerCase().trim());
    }

    checkIsFieldsOkay(): boolean {
        let isOkay = true;
        if (this.evendProduct.name === '' || this.evendProduct.name === undefined) { isOkay = false; }
        if (this.evendProduct.categories[0]._id === '-1') { isOkay = false; }
        if (this.evendProduct.status.toString() === '-1' || this.evendProduct.status === -1 || this.evendProduct.status === undefined) { isOkay = false; }
        if (this.evendProduct.brand === null || !this.evendProduct.brand) { isOkay = false; }
        if (!isOkay) {
            this.errorSwal.text = 'Lütfen tüm alanları doldurunuz!';
            this.errorSwal.show();
            return false;
        } else {
            return true;
        }
    }
    convertToFile(base64Str, fileName: string) {
        const binary = atob(base64Str.base64.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new File([new Uint8Array(array)], fileName , {type: 'image/jpeg', lastModified: Date.now()});
    }

    fileChangeEvent(event: any, isEdit: boolean): void {
        if (isEdit) {
            this.editImageChangedEvent = event;
        } 
    }
    imageCropped(image: string, isEdit: boolean) {
        if (isEdit) {
            this.editCroppedImage = image;
        } 
    }
    imageLoaded(isEdit: boolean) {
        if (isEdit) {
            this.editCropperReady = true;
        }
    }
    imageLoadFailed () {
        this.errorSwal.text = 'Seçtiğiniz resim işlenirken sorun oluştu! Lütfen farklı bir resim deneyiniz';
        this.errorSwal.show();
    }
    clearProduct() {
        this.evendProduct = new EvendProduct();
        this.evendProduct.brand = new ProductBrand(); // this.brand;
        this.evendProduct.brand._id = '-1';
        this.evendProduct.categories = [];
        this.evendProduct.categories.push(new ProductCategory());
        this.evendProduct.categories[0]._id = '-1';
        this.evendProduct.status = -1;
        this.evendProduct.tags = [];

        // ----------------------------------------
        this.editCropInput.nativeElement.value = '';
        this.editImageChangedEvent = '';
        this.editCroppedImage = '';
        this.editCropperReady = false;
        // END : Reset image croppers

        this.errorMessage = '';
    }
    searchEvendProduct() {
        this.spinner.show();
        this.evendProductpage = 1;
        this.productService.getEvendProductsSuperAdmin(this.evendProductpage, 
            {
                categoryId:'' ,
                brandId:'',
                status: this.filter,
                name:this.searchText, 
                evendProductType:''
            })
            .subscribe(response => {
                this.evendProducts = response.result.docs;
                this.evendProductpages = response.result.pages;
                this.totalCountOfEvendProduct = response.result.total;
                this.spinner.hide();
            }, error => {
                this.spinner.hide();
                this.errorSwal.text = 'Arama sonuçları getirilirken hata oluştu!';
                this.errorSwal.show();
            });
        this.spinner.hide();
    }

    getBrand(brandId: string) {
        if (!brandId) { return; }
        this.brandService.getBrand(brandId).subscribe(res => {
            this.evendProduct.brand = res.brand;
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.message;
                this.errorSwal.show();
            }
        });
    }

    getCategory(categoryId: string) {
        if (!categoryId) { return; }
        this.categoryService.getCategory(categoryId).subscribe(res => {
            this.evendProduct.categories[0] = (res.category);
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.message;
                this.errorSwal.show();
            }
        });

    }

    trackFunction(index, item) {
        return `${item.id}-${index}`;
    }

    filterProducts(filter) {
        this.filter = filter;
        switch (filter) {
            case 0:
                this.getEvendProducts();
                break;
            case 1:
                this.getEvendProducts();
                break;
            case 8:
                this.getEvendProducts();
                break;
            case 9:
                this.getEvendProducts();
                break;
        }
    }
    onScroll() {
        if (this.evendProductpage + 1 > this.evendProductpages) { return; }
        $('#page-loader').fadeIn();
        this.evendProductpage += 1;
        this.productService.getEvendProductsSuperAdmin(this.evendProductpage, 
            {
                categoryId: this.productCategoryId, 
                brandId: this.productBrandId,
                status: this.filter,
                name:this.searchText, 
                evendProductType:''})
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.result.docs) {
                    this.evendProducts.push(item);
                }
                this.evendProductpages = response.result.pages;
                this.totalCountOfEvendProduct = response.result.total;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
    }
    onScrollBrand() {
        if (this.brandPage + 1 > this.brandPages) { return; }
          $('#page-loader').fadeIn();
          this.brandPage += 1;
          this.brandService.getAllBrands(this.brandPage)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.brands.push(item);
                      this.brands = [...this.brands];
                  }
                  this.brandPages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.errorSwal.title = 'Automat devamı yüklenemedi!';
                  this.errorSwal.show();      
              });
    }
    onScrollCategory() {
        if (this.categoryPage + 1 > this.categoryPages) { return; }
          $('#page-loader').fadeIn();
          this.categoryPage += 1;
          this.categoryService.getCategories(this.categoryPage)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.categories.push(item);
                      this.categories = [...this.categories];
                  }
                  this.categoryPages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.errorSwal.title = 'Automat devamı yüklenemedi!';
                  this.errorSwal.show();      
              });
    }
    onScrollTags() {
        if (this.tagPage + 1 > this.tagPages) { return; }
          $('#page-loader').fadeIn();
          this.tagPage += 1;
          this.tagService.getAllTags(this.tagPage)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.tags.push(item);
                      this.tags = [...this.tags];
                  }
                  this.tagPages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.errorSwal.title = 'Automat devamı yüklenemedi!';
                  this.errorSwal.show();      
              });
    }
    onScrollTypes() {
        if (this.typePage + 1 > this.typePages) { return; }
          $('#page-loader').fadeIn();
          this.typePage += 1;
          this.productService.getEvendProductTypes(this.typePage)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.productTypes.push(item);
                      this.productTypes = [...this.productTypes];
                  }
                  this.typePages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.errorSwal.title = 'Automat devamı yüklenemedi!';
                  this.errorSwal.show();      
              });
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/product-filter/product-filter.component.ts